import { useState } from "react"
import { Input } from "./ui/shadcn/input"
import { Textarea } from "./ui/shadcn/textarea"
import FilePicker from "./ui/FilePicker"

export default function ShowEditor({ defaultValue, onChange }) {
    const [show, setShow] = useState(defaultValue || {
        name: 'New Show',
        description: ''
    })

    const handleChange = (e) => {
        const newShow = {...show, [e.target.name]: e.target.value}
        setShow(newShow)
        if(onChange) onChange(newShow)
    }

    const handleFileChange = (file) => {
        const newShow = {...show, thumbnailFile: file}
        setShow(newShow)
        if(onChange) onChange(newShow)
    }

    return (
        <div className='flex flex-col gap-4 w-full p-4 flex-1 overflow-y-auto'>
            <div className='flex flex-col gap-2'>
                <label htmlFor="name" className='text-xs text-secondary-foreground'>Name</label>
                <Input name='name' defaultValue={show.name} onChange={handleChange}/>
            </div>
            <div className='flex flex-col gap-2'>
                <label className='text-xs text-secondary-foreground'>Thumbnail</label>
                <FilePicker className='w-full aspect-video' accept='image/*' type='image' name='thumbnailFile' preview={show.thumbnail_url} onChange={handleFileChange}/>
            </div>
            <div className='flex flex-col gap-2'>
                <label htmlFor="description" className='text-xs text-secondary-foreground'>Description</label>
                <Textarea rows={5} name='description' defaultValue={show.description} onChange={handleChange} />
            </div>
        </div>
    )
}